import { Share2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../components/ui/tooltip";
import { toast } from "react-hot-toast";

const ShareButton = () => {
  const copyToClipboard = () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
      toast.success("Copied to clipboard!");
    });
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <li>
            <a
              className="w-[38px] h-[38px] flex justify-center items-center rounded-full text-[var(--store-text)] bg-[var(--store-glass)] backdrop-blur-md border border-[var(--store-border)] hover:bg-[var(--store-glass)] transition-all cursor-pointer"
              onClick={copyToClipboard}
            >
              <Share2 size={20} />
            </a>
          </li>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copy Link</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ShareButton;
